export default __webpack_public_path__ + "static/media/location-icon.66bab846.svg";